<template>
	<div>
		<ArvandGatewayTransactionsPrintHtml :transaction="transaction" :area="area" @ready="$emit('ready')" />
	</div>
</template>

<script>
export default {
	name: 'DefaultGatewayTransactionsPrintHtml',
	components: {
		ArvandGatewayTransactionsPrintHtml: () => import('./GatewayTransactionPrints/ArvandGatewayTransactionsPrintHtml'),
	},
	props: {
		transaction: {
			type: Object,
		},
		area: {
			type: String,
			default: 'admin'
		}
	},
	data: () => ({}),
	mounted() {
	},
	computed: {
	},
	methods: {

	}
}
</script>
<style scoped></style>